defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/Flow',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Ribbon',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PageWrapper',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/ClubCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/FlowProgressBar',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Modal',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/Naming',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/ThemeDesign',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/Settings'
  ],
  function (m, PlayTogetherApi, Utils, Loader, Ribbon, CtaButton, CardFlowHeader, PageWrapper, ClubCard, FlowProgressBar, Modal, Naming, ThemeDesign, Settings) {

    // Context:
    var Flow = {
      controller: function (args) {
        Object.assign(this, args.controller);
        this.navigationPaths = this.settings.navigation;

        this.error = m.prop(null);
        this.helpOverlayTitle = m.prop(null);
        this.helpOverlayDescription = m.prop(null);
        this.helpOverlayCloseButtonText = this.rootDictionary.get('Shared/CloseButton');

        this.flowTitle = m.prop('');
        this.flowDescription = m.prop('');
        this.property('flowGoBack', () => null);

        this.canEditClubName = m.prop(false);
        this.flowSteps = ['choseName', 'themeDesign', 'settings'];
        this.currentStep = m.prop('choseName');

        this.clubName = this.clubModelFields().clubName;
        this.clubTheme = m.prop(this.clubModelFields().theme);
        this.clubBackground = this.clubTheme().background;
        this.clubBadge = this.clubTheme().badge;
        this.clubBadgeBackground = this.clubTheme().badgeBackground;
        this.clubSettings = m.prop(this.clubModelFields().rules);

        this.loadingPersonalizationOptions = m.prop(true);
        this.personalizationOptions = m.prop(null);
        PlayTogetherApi.getPersonalizationOptions()
          .then((response) => {
            this.personalizationOptions(response);
            this.loadingPersonalizationOptions(false);
          })
          .catch((response) => {
            this.error(this.rootDictionary.get(`ErrorMessages/${response.errorMessage}`));
            this.loadingPersonalizationOptions(false);
          });

        this.setThemeVars = function ($element) {
          if (!this.personalizationOptions()) return;

          if (this.clubTheme().colorTheme() && Utils.isValidHexCode(this.clubTheme().colorTheme().code)) {
            Utils.setCssHslVariables({
              hexColor: this.clubTheme().colorTheme().code
            });
          }

          if (this.clubBackground()) {
            $element.style.setProperty('--club-theme-background-image-url', 'url(' + this.clubBackground().url + ')');
          }
        }.bind(this);

        // error handling:
        this.errorModal = new Modal();
        this.isErrorOverlayOn = m.prop(false);
        var onConfirmErrorOverlay = () => {
          this.error(null);
          this.isErrorOverlayOn(false);
        };
        var openErrorOverlay = () => {
          var errorText = this.error();
          const modalContent = this.errorModal.defaultContentTemplate({
            heading: this.rootDictionary?.get('ErrorMessages/GenericTitle'),
            body: m.trust(errorText),
            footer: CtaButton({
              text: this.rootDictionary?.get('ErrorMessages/OkUnderstoodButton'),
              onClick: this.errorModal.close,
              options: ['primary']
            })
          });
          this.errorModal.setContent(modalContent);
          this.errorModal.onClose(onConfirmErrorOverlay);
          this.errorModal.show();
        };
        this.hasError = () => {
          if (this.error() && !this.isErrorOverlayOn()) {
            openErrorOverlay();
            this.isErrorOverlayOn(true);
          }
        };

        // Add event listener for redireting on user logout
        Utils.redirectOnLogout(this.navigationPaths.redirectOnLogoutPage);
        Utils.checkLoginStatus();
      },

      view: function (controller) {
        if (controller.loadingPersonalizationOptions()) {
          return Loader(controller);
        }

        if (controller.error()) {
          controller.hasError();
        }

        const clubNameInput = document.querySelector('input.play-together__ribbon-title');
        const flowFooter = (content) => {
          return [
            content,
            FlowProgressBar(controller.flowSteps, controller.currentStep)
          ];
        };

        const focusEditName = () => {
          if (clubNameInput) {
            clubNameInput.focus();
          }
        };

        const underInputContent = () => {
          if (controller.currentStep() !== 'choseName') {
            return null;
          }

          if (clubNameInput === document.activeElement) {
            const remainingCharactersCount = controller.clubModel().getClubNameRemainingCharactersCount();
            return m('.play-together-club-name-rule',
              controller.dictionary('Flow/NameLengthDescription', { count: remainingCharactersCount > 0 ? remainingCharactersCount : 0 }),
            );
          }

          return CtaButton({
            text: controller.dictionary('Flow/ChangeClubNameButton'),
            onClick: focusEditName,
            icon: 'edit',
            options: ['small']
          });
        };

        const $header = [
          CardFlowHeader({
            goBack: controller.property('flowGoBack'),
            helpOverlay: {
              title: controller.helpOverlayTitle(),
              description: controller.helpOverlayDescription(),
              closeButtonLabel: controller.helpOverlayCloseButtonText,
            }
          })
        ];

        const $content = m('.play-together-create-club-flow', {
          config: controller.setThemeVars
        }, [
          CardFlowHeader({
            title: controller.flowTitle(),
            description: controller.flowDescription(),
          }),
          ClubCard({
            $header: [
              Ribbon({
                asInput: controller.canEditClubName(),
                placeholder: controller.dictionary('Flow/ClubNamePlaceholder'),
                title: controller.clubName,
                badge: controller.clubTheme().badge(),
                badgeBackground: controller.clubTheme().badgeBackground()
              }),
              underInputContent()
            ],
            $content: [
              controller.currentStep() === 'choseName' ? m(Naming, { controller }, { flowFooter }) : null,
              controller.currentStep() === 'themeDesign' ? m(ThemeDesign, { controller }, { flowFooter }) : null,
              controller.currentStep() === 'settings' ? m(Settings, { controller }, { flowFooter }) : null
            ]
          })
        ]);

        return PageWrapper({
          className: '',
          $header,
          $content
        });
      }
    };

    // Public functions:
    return Flow;
  });
